import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking");
  const attempts = useRef(0);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/dashboard"); return; }

    const poll = async () => {
      if (attempts.current >= 12) { setStatus("timeout"); return; }
      attempts.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          const meta = data.metadata || {};
          setTimeout(() => {
            if (meta.type === "order" && meta.order_id) navigate(`/orders/${meta.order_id}/submit`);
            else navigate("/dashboard");
          }, 1500);
          return;
        }
      } catch {}
      setTimeout(poll, 2000);
    };
    poll();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#090A0F] px-6">
      <div className="text-center fade-up" data-testid="payment-success">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-emerald-400 mx-auto mb-6" />
            <h1 className="font-display text-4xl text-white mb-2">Payment confirmed</h1>
            <p className="text-slate-400">Taking you to submit your assets…</p>
          </>
        ) : status === "timeout" ? (
          <>
            <h1 className="font-display text-3xl text-white mb-2">Still processing</h1>
            <p className="text-slate-400">Check your dashboard shortly.</p>
          </>
        ) : (
          <>
            <Loader2 className="w-12 h-12 text-[#D4AF37] mx-auto mb-6 animate-spin" />
            <h1 className="font-display text-3xl text-white mb-2">Confirming payment…</h1>
            <p className="text-slate-400">One moment.</p>
          </>
        )}
      </div>
    </div>
  );
}
